import React, {useState,useEffect} from 'react'
import {BranchProfileImage} from '../../../components/BranchProfileImage'
import styles from './ImageSection.scss'
import { ClientImportLogo, ClientImportSign } from '../../../reducers/clients/clients'
import { CLIENT_FORM } from 'src/constants/FormNames';
import { connect } from 'react-redux'
import { getFormValues, change as formChange } from 'redux-form'
import { withTranslation } from "react-i18next"
import {imageType} from "../../../utils/Form"
import {AddFile} from 'jbc-front/components/icons'

function BranchImageSection({dispatch, logo, signature, t, label, formKey}) {
    const uploadLogo = async (data) => {	
        if (data !== undefined) {
            dispatch(formChange(CLIENT_FORM, `${formKey}.logo`, data))
            dispatch(formChange(CLIENT_FORM, `${formKey}.branchLogo`, null))
        }	
    }	

    const uploadSignature = async (data) => {
        if (data !== undefined) {
            dispatch(formChange(CLIENT_FORM, `${formKey}.signature`, data))
            dispatch(formChange(CLIENT_FORM, `${formKey}.branchSignature`, null))
        }
    }

    const removeLogo = () => {
        dispatch(formChange(CLIENT_FORM, `${formKey}.logo`, null))
        dispatch(formChange(CLIENT_FORM, `${formKey}.branchLogo`, null))
    }

    const removeSignature = () => {
        dispatch(formChange(CLIENT_FORM, `${formKey}.signature`, null))
        dispatch(formChange(CLIENT_FORM, `${formKey}.branchSignature`, null))
    }

    return (
        <React.Fragment>
            <div className={styles.label}>{label}</div>
            <div className={styles.imagesection}>
                <BranchProfileImage edit name="logo" label={t('features.Clients.containers.BranchImageSection.branch_logo')}
                            image={imageType(logo)} uploadImage={uploadLogo} defaultImage={<AddFile size={200} />} removeImage={removeLogo} />

                <BranchProfileImage edit name="signature" label={t('features.Clients.containers.BranchImageSection.branch_signature')}
                            image={imageType(signature)} uploadImage={uploadSignature} aspect={5} defaultImage={<AddFile size={200} />} removeImage={removeSignature} />

                {/* <ProfileImage edit name="employeeImage" label={"Director sign"}/> */}
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = (state, ownProps) => {
    const formKey = ownProps.formKey;
    const idx = formKey.replace(/[^0-9]/g, '');
    return({
        logo: getFormValues("client")(state).clientBranch[Number(idx)].branchLogo || getFormValues("client")(state).clientBranch[Number(idx)].logo,
        signature: getFormValues("client")(state).clientBranch[Number(idx)].branchSignature || getFormValues("client")(state).clientBranch[Number(idx)].signature,
})}

export default connect(mapStateToProps)(withTranslation()(BranchImageSection))